import {
  Avatar,
  Box,
  Button,
  Container,
  Grid,
  InputBase,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
} from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import React, { useState, useEffect, useContext } from "react";
import { Navigate, useParams } from "react-router-dom";
import axios from "axios";
import { AppContext, url } from "../utils";
import WithdrawalTimer from "./Timer";
import { formatUnits, parseUnits } from "@ethersproject/units";
import { Contract } from "ethers";
import createdPresaleAbi from "../utils/createdPresaleAbi.json";
import createdTokenAbi from "../utils/createdTokenAbi.json";
import { toast } from "react-toastify";
import { HashLink } from "react-router-hash-link";
import Loading from "../loading";
import moment from "moment";
import {
  BorderLinearProgress,
  useBusdContract,
  UseSalesContract,
} from "../ConnectivityAss/hooks";
import CopyToClipboard from "react-copy-to-clipboard";
import { AiOutlineCopy } from "react-icons/ai";
import Skeleton from "@mui/material/Skeleton";
import Updatesale from "./IDO/UpdateSale/Updatesale";
import TextField from "./IDO/TextField";
import { saleContractAddress } from "../utils/environment";

function handleClick(event) {
  event.preventDefault();
}
export default function Projectsdetail() {
  let { id } = useParams();
  const matches = useMediaQuery("(max-width:700px)");
  const { account, signer, connect } = useContext(AppContext);

  const busdContract = useBusdContract(signer);
  const [percentage, setpercentage] = useState(0);
  const [Amount, setAmount] = useState(0);
  const [tokenPurchased, settokenPurchased] = useState(0);
  const [investedBUSD, setinvestedBUSD] = useState(0);
  const [walletBalance, setwalletBalance] = useState(0);
  const [Data, SetData] = useState([]);
  const [findData, SetfindData] = useState({});
  const [state, setstate] = useState("0");
  const [loading, setloading] = useState(false);
  const [presaleContract, setpresaleContract] = useState("");
  const [createdTokenContract, setcreatedTokenContract] = useState("");
  const [decimals, setdecimals] = useState("");
  const [allowState, setallowState] = useState(false);
  const [admin, setadmin] = useState(false);
  const [hardcap, sethardcap] = useState(0);
  const [sold, setsold] = useState(0);
  const [presaleAddress, setpresaleAddress] = useState("");
  const [userAllocation, setuserAllocation] = useState("");
  const [tokenAddress, setTokenAddress] = useState("");
  const [tokenDecimel, setTokenDecimel] = useState("");
  const [tokenName, settokenName] = useState("");
  const [tokenContract, settokenContract] = useState();
  const [tokenSymbol, setTokenSymbol] = useState();

  ////////////Project Update///////////
  const [open, setopen] = useState(false);

  const initData = async () => {
    setloading(true);
    try {
      const { data } = await axios.get(`${url}/presaleRouter/IODData/`);
      SetData(data.iod);
      setloading(false);
    } catch (error) {}
  };
  useEffect(() => {
    initData();
  }, []);
  useEffect(() => {
    setloading(true);
    const init = async () => {
      let findData = await Data.filter((item) => item._id == id);
      SetfindData(findData[0]);
      setloading(false);
    };
    if (Data.length > 0) {
      init();
    }
  }, [Data]);

  const initContracts = async () => {
    setloading(true);
    try {
      const presaleContracts = new Contract(
        findData.presaleAddress,
        createdPresaleAbi,
        signer
      );
      setpresaleAddress(findData.presaleAddress);
      setpresaleContract(presaleContracts);
      const tokenContract = new Contract(
        findData.tokenAddress,
        createdTokenAbi,
        signer
      );
      const decimals = await tokenContract.decimals();
      const tokens = await presaleContracts.preSaleTokenBalance(account);
      const admin = await presaleContracts.admin();
      const allow = await presaleContracts.allow();
      const BUSDs = await presaleContracts.BUSDBalance(account);
      let soldBUSD = await presaleContracts.amountRaised();
      const hardcap = await presaleContracts.hardCap();
      const allocation = await presaleContracts.getUserAllocation(account);
      setuserAllocation(+formatUnits(allocation, decimals));
      let percent = (+soldBUSD / +hardcap) * 100;
      setpercentage(percent);
      setadmin(admin);
      sethardcap(formatUnits(hardcap));
      setsold(formatUnits(soldBUSD));
      settokenPurchased(+formatUnits(tokens, decimals));
      setinvestedBUSD(+formatUnits(BUSDs));
      setcreatedTokenContract(tokenContract);
      setallowState(allow);
      setloading(false);
    } catch (error) {
      console.log(error);
    }
    setloading(false);
  };
  useEffect(() => {
    if (findData && account) {
      initContracts();
    }
  }, [findData, account]);

  useEffect(() => {
    const initBalance = async () => {
      try {
        const decimals = await createdTokenContract.decimals();
        setdecimals(decimals);
        const balanceOfToken = await busdContract.balanceOf(account);
        // const balance = await web3.eth.getBalance(account);
        setwalletBalance(formatUnits(balanceOfToken));
      } catch (error) {
        console.log(error);
      }
    };
    if (account && createdTokenContract) {
      initBalance();
    }
  }, [account, createdTokenContract]);

  const buyHandler = async () => {
    if (!account) {
      toast.error("Error! please connect your wallet");
    } else if (+Amount == 0) {
      toast.error("Error! please enter Amount");
    } else if (isNaN(+Amount) || +Amount < 0) {
      toast.error("Error! Please enter a valid Amount");
    } else {
      try {
        setloading(true);
        const txApprove = await busdContract.approve(
          presaleAddress,
          parseUnits(Amount.toString())
        );
        await txApprove.wait();
        const tx = await presaleContract.buy(parseUnits(Amount.toString()));
        await tx.wait();
        toast.success("Success! Transaction confirmed.");
        setloading(false);
        window.location.reload();
      } catch (error) {
        if (error?.data?.message) {
          toast.error(error?.data?.message);
        } else {
          toast.error(error?.message);
        }
        setloading(false);
      }
    }
  };
  const ownerHandler = async () => {
    try {
      setloading(true);
      const tx = await presaleContract.setAllow(!allowState);
      await tx.wait();
      toast.success(
        `Presale successfully ${allowState ? "stoped." : "started."}`
      );
      setloading(false);
      initContracts();
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
      } else {
        toast.error(error?.message);
      }
      setloading(false);
    }
  };

  // const tokenAddressHandler = async (address) => {
  //   try {
  //     setloading(true);
  //     setTokenAddress(address);
  //     if (!account) {
  //       toast.error("Please connect your wallet first.");
  //     }

  //     if (
  //       address != "0x0000000000000000000000000000000000000000" &&
  //       account &&
  //       address?.length == 42
  //     ) {
  //       setloading(true);
  //       const TokenContract = await new Contract(
  //         address,
  //         createdTokenAbi,
  //         signer
  //       );
  //       const decimals = await TokenContract.decimals();
  //       const name = await TokenContract.name();
  //       const symbol = await TokenContract.symbol();
  //       const tNumberOftokens = await TokenContract.balanceOf(account);
  //       const allowance = await TokenContract.allowance(
  //         account,
  //         saleContractAddress
  //       );
  //       setTokenSymbol(symbol);
  //       setTokenDecimel(decimals);
  //       settokenName(name);
  //       settokenContract(TokenContract);
  //       setloading(false);
  //     } else {
  //       toast.success("You can chenge the zero address");
  //       setloading(false);
  //     }
  //   } catch (error) {
  //     setloading(false);
  //     toast.error("invalid token address");
  //     console.log(error);
  //   }
  // };
  // useEffect(() => {
  //   if (account && tokenAddress) {
  //     tokenAddressHandler(tokenAddress);
  //   }
  // }, [account, tokenAddress]);
  const setAddressHandler = async () => {
    try {
      setloading(true);
      if (!tokenAddress) {
        toast.error("Please enter token address");
      } else {
        const add = await presaleContract.setPreSaleTokenAddress(tokenAddress);
        await add.wait();
        toast.success("Transection Confirmed");
        setloading(false);
      }
    } catch (error) {
      if (error?.data?.message) {
        toast.error(error?.data?.message);
        setloading(false);
      } else {
        toast.error(error?.message);
        setloading(false);
      }
    }
  };
  const deleteHandler = async () => {
    try {
      setloading(true);
      const data = await axios.put(
        `${url}/presaleRouter/delete/${findData._id}`
      );
      if (data.success) {
        toast.success(data.message);
        setloading(false);
        <Navigate to="/" />;
      } else {
        toast.error(data.message);
        setloading(false);
      }
    } catch (error) {}
  };
  return (
    <>
      <Updatesale findData={findData} open={open} setopen={setopen} />
      <Loading loading={loading} />
      <Box pt={5} pb={10}>
        <Container maxWidth="lg">
          <Stack direction="row" spacing={1}>
            <Box fontFamily="Raleway">
              <div role="presentation" onClick={handleClick}>
                <Breadcrumbs aria-label="breadcrumb">
                  <HashLink
                    to="/projects/#liveprojects"
                    smooth
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#05C3DE",
                    }}
                  >
                    Projects
                  </HashLink>
                  <Box
                    style={{ display: "flex", alignItems: "center" }}
                    color="inherit"
                  >
                    {findData?.projectName}
                  </Box>
                </Breadcrumbs>
              </div>
            </Box>
          </Stack>
          <Stack direction="row" spacing={3} my={4} alignItems="center">
            {loading ? (
              <Skeleton variant="circular">
                <Avatar />
              </Skeleton>
            ) : (
              <Avatar sx={{ width: 70, height: 70 }}>
                <img src={findData.logoLink} />
              </Avatar>
            )}

            <Box>
              {loading ? (
                <Skeleton width="100%">
                  <Box>.</Box>
                </Skeleton>
              ) : (
                <Box fontFamily="Raleway" fontSize={{ xs: "20px", md: "42px" }}>
                  {findData?.tokenName}
                </Box>
              )}

              <Box display="flex" alignItems="center" justifyContent="center">
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 11px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={findData?.telegramLink}
                  target="_blank"
                >
                  <i className="fab fa-telegram-plane"></i>
                </a>

                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={findData?.twitterLink}
                  target="_blank"
                >
                  <i className="fab fa-twitter"></i>
                </a>
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={findData?.redditLink}
                  target="_blank"
                >
                  <i className="fab fa-reddit-alien"></i>
                </a>
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={findData?.webLink}
                  target="_blank"
                >
                  <i className="fal fa-globe"></i>
                </a>
                <a
                  style={{
                    background:
                      "linear-gradient(94.25deg, #0A0E21 0%, #1B0C2B 98%)",
                    borderRadius: "100px",
                    fontSize: "20px",
                    padding: "5px 10px",
                    marginRight: matches ? "6px" : "20px",
                    color: "#fff",
                  }}
                  href={findData?.githubLink}
                  target="_blank"
                >
                  <i className="fab fa-github-alt"></i>
                </a>
              </Box>
            </Box>
          </Stack>
          <Grid container mt={6}>
            {loading ? (
              <Skeleton variant="rectangular" width="70%">
                <div style={{ paddingTop: "57%" }} />
              </Skeleton>
            ) : (
              <Grid item xs={12} md={8}>
                <img src={findData.coverImage} />
              </Grid>
            )}
          </Grid>
          <Box>
            <Stack
              direction="row"
              spacing={3}
              my={2}
              cursor="pointer"
              borderBottom="1px solid grey"
            >
              <Button
                size="large"
                style={{ color: "#fff", padding: "20px" }}
                onClick={() => {
                  setstate("0");
                }}
              >
                Description
              </Button>
              <Button
                size="large"
                style={{ color: "#fff", padding: "20px" }}
                onClick={() => {
                  setstate("1");
                }}
              >
                Token Sale
              </Button>
            </Stack>
            {state === "0" ? (
              <Box>
                <Grid item xs={12} md={6} px={2} mt={{ xs: 5, sm: 5, md: -1 }}>
                  <Box mb={8}>
                    <Box
                      fontFamily="Raleway"
                      fontSize={{ xs: "28px", md: "42px" }}
                      fontWeight="700"
                    >
                      HEADINGS
                    </Box>

                    <br />
                    <Box
                      px={matches ? 1 : 3}
                      width="100%"
                      fontFamily="Raleway"
                      fontSize={{ xs: "14px", md: "18px" }}
                      fontWeight="400"
                    >
                      {findData.projectDescription}
                    </Box>
                  </Box>
                </Grid>
                <br />
              </Box>
            ) : (
              <Box my={4}>
                <Container maxWidth="lg">
                  <Grid container spacing={5}>
                    <Grid item xs={12} sm={6}>
                      <TableContainer
                        style={{
                          boxShadow: "#ffffff 0px 0px 15px -2px",
                          borderRadius: "10px",
                        }}
                        component={Paper}
                      >
                        <Table
                          style={{
                            color: "#fff",
                            background: "#271942",
                            boxShadow: "#ffffff 0px 0px 15px -2px",
                          }}
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell
                                sx={{ color: "#fff", fontFamily: "Raleway" }}
                              >
                                Project Key Metrics
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {admin &&
                            account?.toLowerCase() == admin?.toLowerCase() ? (
                              <>
                                <TableRow>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    borderBottom="1px solid #fff"
                                  >
                                    <TableCell
                                      sx={{
                                        color: "Grey",
                                        borderStyle: "none",
                                      }}
                                    >
                                      {allowState ? "Stop Sale" : "Start Sale"}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "Grey",
                                        borderStyle: "none",
                                      }}
                                    >
                                      <Box
                                        mt={2}
                                        fontWeight="500"
                                        fontSize="18px"
                                        textAlign="center"
                                        fontFamily="Raleway"
                                        px={1}
                                        py={1}
                                        borderRadius="20px"
                                        width="150px"
                                        onClick={() => ownerHandler()}
                                        style={{
                                          cursor: "pointer",
                                          color: "#ffffff",
                                          background:
                                            "linear-gradient(360deg, #26058E 50%, #A301F7)",
                                        }}
                                      >
                                        {allowState
                                          ? "Stop Sale"
                                          : "Start Sale"}
                                      </Box>
                                    </TableCell>
                                  </Box>
                                </TableRow>
                                <TableRow>
                                  <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                    borderBottom="1px solid #fff"
                                  >
                                    <TableCell
                                      sx={{
                                        color: "Grey",
                                        borderStyle: "none",
                                      }}
                                    >
                                      <TextField
                                        type="text"
                                        placeholder="Enter Address here"
                                        className="fieldText"
                                        value={tokenAddress}
                                        onChange={(e) => {
                                          setTokenAddress(e.target.value);
                                        }}
                                        maxLength={42}
                                      />
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "Grey",
                                        borderStyle: "none",
                                      }}
                                    >
                                      <Box
                                        fontWeight="500"
                                        fontSize="14px"
                                        textAlign="center"
                                        fontFamily="Raleway"
                                        px={1}
                                        py={1}
                                        borderRadius="20px"
                                        width="100px"
                                        onClick={() => setAddressHandler()}
                                        style={{
                                          cursor: "pointer",
                                          color: "#ffffff",
                                          background:
                                            "linear-gradient(360deg, #26058E 50%, #A301F7)",
                                        }}
                                      >
                                        Set Address
                                      </Box>
                                    </TableCell>
                                  </Box>
                                </TableRow>
                              </>
                            ) : null}

                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Sale Price
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {findData?.presaleRate}
                                </TableCell>
                              </Box>
                            </TableRow>
                            {findData.pancakeListRate && (
                              <TableRow>
                                <Box
                                  display="flex"
                                  alignItems="center"
                                  justifyContent="space-between"
                                  borderBottom="1px solid #fff"
                                >
                                  <TableCell
                                    sx={{
                                      color: "Grey",
                                      borderStyle: "none",
                                      fontFamily: "Raleway",
                                    }}
                                  >
                                    Dex Price
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      color: "Grey",
                                      borderStyle: "none",
                                      fontFamily: "Open Sans",
                                    }}
                                  >
                                    {findData.pancakeListRate}
                                  </TableCell>
                                </Box>
                              </TableRow>
                            )}

                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Your Allocation
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {parseFloat(userAllocation).toFixed(3)}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Token Purchased
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {tokenPurchased}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Invested BUSD
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {investedBUSD}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Sale Start Time (UTC)
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {moment
                                    .unix(+findData.startTime)
                                    .format("LL")}
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Sale End Time (UTC)
                                </TableCell>
                                <TableCell
                                  sx={{ color: "Grey", borderStyle: "none" }}
                                >
                                  <WithdrawalTimer
                                    endTime={+findData.endTime}
                                  />
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Soft Cap
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "OPen Sans",
                                  }}
                                >
                                  {findData.softcap} BUSD
                                </TableCell>
                              </Box>
                            </TableRow>
                            <TableRow>
                              <Box
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                borderBottom="1px solid #fff"
                              >
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Raleway",
                                  }}
                                >
                                  Hard Cap
                                </TableCell>
                                <TableCell
                                  sx={{
                                    color: "Grey",
                                    borderStyle: "none",
                                    fontFamily: "Open Sans",
                                  }}
                                >
                                  {findData.hardcap} BUSD
                                </TableCell>
                              </Box>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Box
                        display="flex"
                        alignItems="center"
                        flexDirection="column"
                        bgcolor="#271942"
                        borderRadius="10px"
                        boxShadow="#ffffff 0px 0px 15px -2px"
                        height="100%"
                        px={3}
                        py={5}
                      >
                        <Box
                          fontWeight="500"
                          fontSize="25px"
                          fontFamily="Raleway"
                        >
                          Buy Tokens
                        </Box>
                        <Box fontFamily="Open Sans" mt={3}>
                          {percentage}%
                        </Box>
                        <Box width="100%">
                          <BorderLinearProgress
                            style={{ height: 20, marginTop: 10 }}
                            variant="determinate"
                            value={percentage}
                          />
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                          >
                            <Box>{+sold} BUSD</Box>
                            <Box> {+hardcap} BUSD</Box>
                          </Box>
                        </Box>
                        <Box
                          display="flex"
                          alignItems="center"
                          mt={3}
                          mb={1}
                          style={{
                            border: "2px solid #A301F7",
                            // backgroundColor: "#000000",
                            borderRadius: "3px",
                          }}
                          width="100%"
                          pb={1}
                        >
                          <InputBase
                            style={{
                              color: "#fff",
                              fontWeight: 400,
                              fontSize: 17,
                              marginTop: 10,
                              width: "100%",
                              paddingRight: "15px",
                              backgroundColor: "transparent",
                              paddingLeft: "15px",
                              fontFamily: "Open Sans",
                            }}
                            fullWidth
                            type="text"
                            id="standard-basic"
                            variant="standard"
                            placeholder="Enter Amount"
                            value={Amount}
                            onChange={(e) => {
                              setAmount(e.target.value);
                            }}
                          />
                          <Box
                            color="#fff"
                            mr={1}
                            pt={1}
                            sx={{ cursor: "pointer" }}
                            fontFamily="Raleway"
                            onClick={() => {
                              account
                                ? setAmount(walletBalance)
                                : toast.error(
                                    "Error! Please connect your wallet"
                                  );
                            }}
                          >
                            Max
                          </Box>
                        </Box>
                        {account ? (
                          <Box
                            mt={2}
                            fontWeight="500"
                            fontSize="18px"
                            textAlign="center"
                            fontFamily="Raleway"
                            px={3}
                            py={1}
                            borderRadius="20px"
                            width="250px"
                            onClick={() => buyHandler()}
                            style={{
                              cursor: "pointer",
                              background:
                                "linear-gradient(360deg, #26058E 50%, #A301F7)",
                            }}
                          >
                            Buy
                          </Box>
                        ) : (
                          <Box
                            mt={2}
                            fontWeight="500"
                            fontSize="18px"
                            textAlign="center"
                            fontFamily="Raleway"
                            width="250px"
                            px={3}
                            py={1}
                            borderRadius="20px"
                            onClick={() => connect()}
                            style={{
                              cursor: "pointer",
                              background:
                                "linear-gradient(360deg, #26058E 50%, #A301F7)",
                            }}
                          >
                            Connect
                          </Box>
                        )}
                        {admin &&
                        account?.toLowerCase() == admin?.toLowerCase() ? (
                          <>
                            <Box
                              mt={2}
                              fontWeight="500"
                              fontSize="18px"
                              textAlign="center"
                              fontFamily="Raleway"
                              px={3}
                              py={1}
                              borderRadius="20px"
                              width="250px"
                              onClick={() => setopen(true)}
                              style={{
                                cursor: "pointer",
                                background:
                                  "linear-gradient(360deg, #26058E 50%, #A301F7)",
                              }}
                            >
                              Edit Sale Data
                            </Box>
                            <Box
                              mt={2}
                              fontWeight="500"
                              fontSize="18px"
                              textAlign="center"
                              fontFamily="Raleway"
                              px={3}
                              py={1}
                              borderRadius="20px"
                              width="250px"
                              onClick={() => deleteHandler()}
                              style={{
                                cursor: "pointer",
                                background:
                                  "linear-gradient(360deg, #26058E 50%, #A301F7)",
                              }}
                            >
                              Delete Sale
                            </Box>
                          </>
                        ) : null}
                      </Box>
                    </Grid>
                  </Grid>
                </Container>
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    </>
  );
}
